import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const ChangePasswordComponent = React.lazy(() => import("../Components/RootComponents/ChangePasswordComponent"));
const ChangePasswordPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ChangePasswordComponent />
      </Suspense>
    </Fragment>
  );
};

export default ChangePasswordPage;
